import {
    useMutation,
    useQueryClient
} from '@tanstack/react-query'
import { useMethods } from '@shared/hooks/methods'

export function useRestMutation({
    invalidate=[],
    process,
    onBegin,
    onFinish,
    onRaise
}) {
    const queryClient = useQueryClient()
    const { showMessage } = useMethods()
    const beginDefault = () => showMessage({
        text: 'جارٍ تنفيذ الإجراء...',
        loading: true
    })
    const finishDefault = () => showMessage({ text: 'اكتمل الإجراء بنجاح' })
    const raiseDefault = (e) => showMessage({
        text: 'detail' in e.response?.data
            ? e.response.data.detail
            : 'حدث خطأ، لم يكتمل الإجراء'
    })

    const mutation = useMutation({
        mutationFn: process,
        onMutate: !!onBegin
            ? (...reactQueryProps) => onBegin(beginDefault, ...reactQueryProps)
            : beginDefault,
        onSuccess: (...reactQueryProps) => {
            if (!!onFinish) onFinish(finishDefault, ...reactQueryProps)
            else finishDefault()
            invalidate.forEach(key => queryClient.invalidateQueries({ queryKey: key }))
        },
        onError: !!onRaise
            ? (...reactQueryProps) => onRaise(raiseDefault, ...reactQueryProps)
            : raiseDefault,
    })

    return mutation
}